import {
  MobileHeaderOptionsContext,
  MobileHeaderSetterContext,
  type MobileHeaderOptions,
} from "@/contexts/mobile-header-context";
import { type ReactNode, useState } from "react";

/** Holds what the current mobile screen shows in the shared header. */
export function MobileHeaderProvider({
  children,
}: {
  readonly children: ReactNode;
}) {
  const [options, setOptions] = useState<MobileHeaderOptions>({});
  return (
    <MobileHeaderSetterContext.Provider value={setOptions}>
      <MobileHeaderOptionsContext.Provider value={options}>
        {children}
      </MobileHeaderOptionsContext.Provider>
    </MobileHeaderSetterContext.Provider>
  );
}
